import { Table } from '@tanstack/react-table'

import { Log, FilterType, DailyLogCode, MileageLossCode } from '@/types/logs'
import { extractParts, compareValueWithPrefix } from '@/helpers/compareValueWithPrefix'

const dailyLogCodes: string[] = Object.values(DailyLogCode)

export const formatFleetFilterValues = (
    values: string[],
    table: Table<Log>,
    filter: FilterType = FilterType.All
): string[] => {
    const availableFleets: string[] = table.getCoreRowModel().rows.reduce<string[]>((acc, row) => {
        if (!row.original.fleet) {
            return acc
        }

        if (filter === FilterType.DailyLog && dailyLogCodes.includes(row.original.code)) {
            acc.push(...row.original.fleet)
        }

        if (filter === FilterType.MileageLoss && row.original.code in MileageLossCode) {
            acc.push(...row.original.fleet)
        }

        if (filter === FilterType.All) {
            acc.push(...row.original.fleet)
        }

        return acc
    }, [])

    const filteredValues = values.reduce<string[]>(
        (acc, fleet) => (availableFleets.includes(fleet) ? [...acc, fleet] : acc),
        []
    )

    return filteredValues.sort((a, b) => {
        const [prefixA, numA, suffixA] = extractParts(a)
        const [prefixB, numB, suffixB] = extractParts(b)

        return compareValueWithPrefix([prefixA, numA, suffixA], [prefixB, numB, suffixB])
    })
}
